import React from 'react';
import SvgIcon from 'material-ui/SvgIcon';

const RecreationalIcon = (props) => (
  <SvgIcon viewBox="0 0 30 35" {...props}>
    <path fill="none" stroke={props.color} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M10,2v60h44V2H10z"/>
    <g>
		  <line fill="none" stroke={props.color} strokeWidth="4" strokeLinejoin="round" strokeMiterlimit="10" x1="47" y1="44" x2="17" y2="44"/>
  		<line fill="none" stroke={props.color} strokeWidth="4" strokeLinejoin="round" strokeMiterlimit="10" x1="47" y1="52" x2="17" y2="52"/>
    </g>
    <polygon fill="none" stroke={props.color} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="44,19 44,29 37,29 37,36 27,36 27,29 20,29 20,19 27,19 27,12 37,12 37,19 "/>
</SvgIcon>

);

export default RecreationalIcon;



// WEBPACK FOOTER //
// ./src/icons/RecreationalIcon.jsx